import React, { useState, useEffect } from "react";
import Sidebar from "../../components/Sidebar";
import "./transaction_company.css";
import { FaArrowUp, FaArrowDown, FaPlus } from "react-icons/fa";

export default function TransactionCompanyPage() {
  const [searchQuery, setSearchQuery] = useState("");
  const [transactions, setTransactions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalExpenses, setTotalExpenses] = useState(0);
  const [net, setNet] = useState(0);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      const mockTransactions = [
        {
          id: 1,
          description: "Payment Received",
          vendor: "ABC Ltd",
          date: "2025-10-20",
          category: "Sales",
          reference: "INV-101",
          amount: 1500.0,
          status: "Completed",
        },
        {
          id: 2,
          description: "Office Supplies",
          vendor: "XYZ Traders",
          date: "2025-10-22",
          category: "Expense",
          reference: "EXP-303",
          amount: -250.0,
          status: "Pending",
        },
        {
          id: 3,
          description: "Service Revenue",
          vendor: "Tech Co.",
          date: "2025-10-25",
          category: "Income",
          reference: "INV-205",
          amount: 900.0,
          status: "Completed",
        },
      ];

      setTransactions(mockTransactions);
      const income = mockTransactions
        .filter((t) => t.amount > 0)
        .reduce((sum, t) => sum + t.amount, 0);
      const expenses = mockTransactions
        .filter((t) => t.amount < 0)
        .reduce((sum, t) => sum + Math.abs(t.amount), 0);
      setTotalIncome(income);
      setTotalExpenses(expenses);
      setNet(income - expenses);
      setIsLoading(false);
    }, 1000);
  }, []);

  const filteredTransactions = transactions.filter(
    (t) =>
      t.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      t.vendor.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="app">
      <Sidebar />
      <main className="main">
        <div className="transaction-header">
          <div>
            <h2 className="page-title">Transactions</h2>
            <p className="page-subtitle">Track all your business activity</p>
          </div>
        </div>
        <input
          type="text"
          placeholder="Search transactions..."
          className="search-input"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <div className="summary-container">
          <div className="summary-card">
            <h4>Total Income</h4>
            <p className="income">${totalIncome.toFixed(2)}</p>
          </div>
          <div className="summary-card">
            <h4>Total Expenses</h4>
            <p className="expense">${totalExpenses.toFixed(2)}</p>
          </div>
          <div className="summary-card">
            <h4>Net</h4>
            <p className="net">${net.toFixed(2)}</p>
          </div>
        </div>
        <div className="recent-header">
          <h3 className="section-title">
            Recent Activity ({transactions.length})
          </h3>
          {/* <button className="add-btn" onClick={() => setShowModal(true)}>
            <FaPlus /> Add
          </button> */}
        </div>
        <div className="transaction-list">
          {isLoading ? (
            <p>Loading transactions...</p>
          ) : filteredTransactions.length > 0 ? (
            filteredTransactions.map((t) => (
              <div className="transaction-card" key={t.id}>
                <div
                  className={`icon ${
                    t.amount > 0 ? "icon-income" : "icon-expense"
                  }`}
                >
                  {t.amount > 0 ? <FaArrowUp /> : <FaArrowDown />}
                </div>
                <div className="transaction-content">
                  <h4>
                    {t.description} - {t.vendor}
                  </h4>
                  <p>
                    {t.date} • {t.category} • {t.reference}
                  </p>
                </div>
                <div className="transaction-amount">
                  <strong
                    style={{ color: t.amount > 0 ? "#137333" : "#C5221F" }}
                  >
                    {t.amount > 0
                      ? `+$${t.amount.toFixed(2)}`
                      : `-$${Math.abs(t.amount).toFixed(2)}`}
                  </strong>
                  <p className="status">{t.status}</p>
                </div>
              </div>
            ))
          ) : (
            <p>No transactions found.</p>
          )}
        </div>

        {showModal && (
          <div className="modal-overlay" onClick={() => setShowModal(false)}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
              <h3>Add Transaction</h3>
              <p>This feature is under development.</p>
              <button className="close-btn" onClick={() => setShowModal(false)}>
                Close
              </button>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
